import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

export const StyledFooter = styled.footer`
  display: flex;
  flex-wrap: wrap;
  color: ${themeGet('colors.whiteSnow')};
  max-width: 100vw;
  overflow-x: hidden;
  .desktop-footer-img {
    position: relative;
    top: 3px;
    min-width: 100vw;
    @media only screen and (max-width: ${themeGet('breakpoints.md')}) {
      display: none;
    }
  }

  .mobile-footer-img {
    display: none;
    position: relative;
    top: 1px;
    @media only screen and (max-width: ${themeGet('breakpoints.md')}) {
      display: block;
    }
  }

  .footer-wrapper {
    width: 100%;
    background-color: ${themeGet('colors.spinDark')};
  }

  .footer-container {
    padding: 15px;
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    max-width: ${themeGet('document.maxWidth')};
    margin: 0 auto;

    @media only screen and (max-width: 1000px) {
      padding: 15px 50px;
    }

    @media only screen and (max-width: ${themeGet('breakpoints.md')}) {
      padding: 15px 25px;
      margin-top: -90px;
    }

    @media only screen and (max-width: ${themeGet('breakpoints.sm')}) {
      padding: 15px 11px;
    }

    .footer-content {
      /* max-width: 1800px because there is 100px padding on each side and we want the actual content to be max 1600px */
      max-width: 1800px;
      margin: 0 auto;
      padding: 15px 100px;
      display: flex;
      flex-wrap: wrap;
    }
  }

  img {
    display: block;
    width: 100%;
  }

  h2,
  h3,
  h4 {
    color: ${themeGet('colors.white')};
    font-family: 'Rubik', sans-serif;
    font-weight: 700;
    font-size: 0.9375rem;
    line-height: 1.15rem;
    margin-bottom: 25px;

    @media only screen and (max-width: ${themeGet('breakpoints.md')}) {
      font-size: 0.95rem !important;
      line-height: 1.15rem;
    }
  }

  li {
    margin-bottom: 0;
  }

  a {
    color: ${themeGet('colors.white')};
    font-size: 0.88rem;
    line-height: 0.88rem;
  }

  a:hover {
    color: ${themeGet('colors.spinSecondaryOne')};
  }

  a:first-of-type {
    width: 20%;
    @media only screen and (max-width: ${themeGet('breakpoints.md')}) {
      margin-bottom: 25px;
    }
    img {
      max-width: 147px;

      @media only screen and (max-width: ${themeGet('breakpoints.md')}) {
        width: 80px;
      }
    }
  }
`;

// section with our brands and connect with us
export const FooterTop = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: baseline;
  width: 80%;
  @media only screen and (max-width: ${themeGet('breakpoints.md')}) {
    width: 100%;
  }

  div:first-of-type {
    display: flex;

    nav:first-of-type {
      @media only screen and (max-width: 600px) {
        width: 100%;
      }

      ul {
        @media only screen and (max-width: 600px) {
          display: flex;
          li {
            width: 50%;
          }
        }
      }
    }
    nav {
      @media only screen and (max-width: ${themeGet('breakpoints.md')}) {
        margin-bottom: 20px;
      }
      width: 180px;
      @media only screen and (max-width: 400px) {
        width: 160px;
      }
      @media only screen and (max-width: 350px) {
        width: 140px;
      }
      ul {
        li {
          padding-bottom: 0;

          span {
            display: block;
            margin-bottom: 10px;
            line-height: 1.15rem;
            color: ${themeGet('colors.white')};
          }
        }
      }
    }
  }
  nav {
    width: 100%;

    a:first-of-type {
      img {
        width: 40px;
      }
    }
  }
`;

// the section at v bottom with copyright
export const FooterBottom = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: baseline;
  width: 100%;
  border-top: 1px solid ${themeGet('colors.spinLight')};
  padding-top: 30px;
  margin-top: 20px;
  font-size: 0.7rem;
  line-height: 0.88rem;

  .privoMobileView{
    display: none;
  }

  .terms-of-service-links {
    .containertest {
      display: flex;
    }
    .cookiepref a {
      line-height: 33px;
      margin-left: 30px;
      font-weight: 900;
    }
    .cookiepref:hover {
      cursor: pointer;
    }
  }

  @media only screen and (max-width: 600px) {
    flex-direction: column-reverse;
    .terms-of-service-links {
      .cookiepref a {
        line-height: 33px;
        margin-left: 0;
        font-size: 14px;
      }
      a {
        margin-right: 15px;
      }
    }
  }

  @media screen and (max-width: ${themeGet('breakpoints.md')}) {
    margin-top: 1.625rem;
    padding-top: 1.625rem;

    .privoMobileView{
      display: block;
    }

    .privoLogo {
      margin-bottom: 30px
    }
  }
  nav {
    padding: 0;
    width: 100%;
  }
  .terms-of-service-links {
    li {
      background-color: transparent;
    }
    li:last-of-type {
      padding-right: 0;
    }
  }
`;

export const FooterLeft = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;

  span.language {
    margin-right: 50px;
    font-size: 0.88rem;
    font-weight: 700;
  }
  span.legal-text {
    max-width: 600px;
  }
`;

export const FooterRight = styled.div`
  padding-right: 50px;

  h2,
  h3 {
    margin-bottom: 0;
  }

  li {
    margin-left: 15px !important;
  }
  li:first-of-type {
    margin-left: 0 !important;
  }
  a {
    font-size: 0.7rem;
    line-height: 0.88rem;
  }

  .privacylinks, .cookiepref{
    margin-top: 5%
  }

  .privo {
    margin-left: 20px
  }

  .privoLogo {
    width: 50px
  }

  @media screen and (max-width: ${themeGet('breakpoints.md')}) {
    width: 100%;
    padding-right: 0;
    padding-bottom: 20px;

    .privoDesktopView{
      display: none;
    }
    ul {
      width: 100%;
      justify-content: space-between;
      li {
        margin: 0;
        margin-left: 0 !important;
        margin-right: 5px !important;
        padding: 0;
        justify-content: center;
      }
      img {
        width: 40px;
        height: 40px;
        margin: 0;
        padding: 0%;
      }
    }
    &.socialBlock {
      padding-bottom: 0;
      ul {
        width: 100%;
        justify-content: start;
        flex-direction: row;
        margin-top: 1.625rem;
        li {
          width: 40px;
          height: 40px;
          margin-right: 1rem !important;
          &:last-child {
            margin-right: 0 !important;
          }
          img {
            width: 100%;
            height: 100%;
            position: static;
            display: inline-block;
          }
        }
      }
    }
  }
`;

export const FooterWave = styled.div`
  background: url(${(props) => props.img}) no-repeat;
  width: 100vw;
  height: 151px;
  border-bottom: 1px solid #01178a;
  background-position: center bottom;
  @media only screen and (min-width: ${themeGet('breakpoints.xl')}) {
    height: 200px;
    min-width: 100vw;
  }
`;
